import { PropertyCollectionKey } from '../types';

export interface PropertyFilters {
  query: string;
  type: string;
  transaction_type: string;
  min_price: string;
  max_price: string;
  bedrooms: string;
  bathrooms: string;
  min_area: string;
  max_area: string;
  city: string;
  neighborhood: string;
  condominium: string;
  category_id: string;
  collection: PropertyCollectionKey | '';
}

const isPropertyCollection = (value: string | null): value is PropertyCollectionKey =>
  value === 'destaques' || value === 'mais-oportunidades';

const readTransactionType = (value: string | null) =>
  value === 'venda' || value === 'aluguel' || value === 'venda_aluguel' ? value : '';

export const readFilters = (searchParams: URLSearchParams): PropertyFilters => {
  const collection = searchParams.get('collection');
  const transactionType = readTransactionType(searchParams.get('transaction_type'));
  return {
    query: searchParams.get('q') || searchParams.get('query') || '',
    type: searchParams.get('type') || '',
    transaction_type: transactionType,
    min_price: transactionType
      ? searchParams.get('min_price') || searchParams.get('minPrice') || ''
      : '',
    max_price: transactionType
      ? searchParams.get('max_price') || searchParams.get('maxPrice') || ''
      : '',
    bedrooms: searchParams.get('bedrooms') || '',
    bathrooms: searchParams.get('bathrooms') || '',
    min_area: searchParams.get('min_area') || '',
    max_area: searchParams.get('max_area') || '',
    city: searchParams.get('city') || '',
    neighborhood: searchParams.get('neighborhood') || searchParams.get('bairro') || '',
    condominium: searchParams.get('condominium') || searchParams.get('condominio') || '',
    category_id: searchParams.get('category_id') || '',
    collection: isPropertyCollection(collection) ? collection : '',
  };
};

export const serializeFilters = (filters: PropertyFilters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key === 'query' ? 'q' : key, value);
  });
  return params;
};

export const filtersAreEqual = (first: PropertyFilters, second: PropertyFilters) =>
  (Object.keys(first) as Array<keyof PropertyFilters>).every(
    (key) => first[key] === second[key]
  );

export const formatPropertyCount = (count: number) =>
  `${count} ${count === 1 ? 'imóvel' : 'imóveis'}`;
